import { Stack } from "@mui/material";
import { Controller } from "react-hook-form";

import { FormControl } from "@/Components/v2/atoms/FormControl/FormControl";
import { DollarTextField } from "@/Components/v2/atoms/TextField";
import { BaseTypography } from "@/Components/v2/atoms/Typography";
import { Typography } from "@/Components/v2/atoms/Typography/Typography";
import { FormCard } from "@/Components/v2/molecule/FormContainer";
import { brandColors } from "@/Components/v2/utils/brand-colors";
import { HIDE_DECIMAL, useConfig } from "@/hooks/useConfig";
import { isDefined } from "@/Utils/array-utils";

import { useScenarioForms } from "./ScenarioFormProvider";
import { Skeleton } from "@/Components/v2/atoms/Skeleton";

export const ScenarioTotalBudgetForm: React.FC = () => {
  const {
    budgetAllocationForm,
    handleTotalBudgetChange,
    maxAllowedTotalBudget,
    isSpendConstraintsLoading,
  } = useScenarioForms();
  const { config } = useConfig();
  const currencySymbol = config.currency.getSymbol();
  const formatCurrency = config.currency.formatCurrency;

  const helperText = isDefined(maxAllowedTotalBudget)
    ? `Acceptable range: ${formatCurrency(
        0
      )} - ${formatCurrency(maxAllowedTotalBudget, HIDE_DECIMAL)}`
    : "";

  return (
    <FormCard
      title="Budget"
      subtitle="Specify your budget for this scenario. You can allocate up to double your historical spend."
    >
      <Stack spacing={2.5}>
        <FormControl>
          <Typography fontWeight={600} mb={1} variant="body1">
            Total Budget
          </Typography>
          <Controller
            name={"totalBudget"}
            control={budgetAllocationForm.control}
            render={({ field, fieldState }) => (
              <>
                <DollarTextField
                  allowNegative={false}
                  error={!!fieldState.error}
                  id={"totalBudget"}
                  name={"totalBudget"}
                  size="small"
                  fullWidth={false}
                  disabled={!isDefined(maxAllowedTotalBudget)}
                  value={field.value ?? ""}
                  onChange={(value) => handleTotalBudgetChange("totalBudget", value ?? null)}
                  onBlur={field.onBlur}
                  currencySymbol={currencySymbol}
                  sx={{ maxWidth: "400px" }}
                />
                {fieldState.error && (
                  <BaseTypography variant="body2" color={brandColors.delete} mt={1}>
                    {fieldState.error.message}
                  </BaseTypography>
                )}
              </>
            )}
          />
        </FormControl>
        {isSpendConstraintsLoading && <Skeleton variant="text" width={200} height={20} />}
        {!isSpendConstraintsLoading && helperText && (
          <Typography fontSize={12}>{helperText}</Typography>
        )}
      </Stack>
    </FormCard>
  );
};

export default ScenarioTotalBudgetForm;
